// extracted by mini-css-extract-plugin
export default {"main":"policy_main__RC11i"};